import { render, staticRenderFns } from "./Lgx243725849601837204.vue?vue&type=template&id=c7b080d8&scoped=true&"
import script from "./Lgx243725849601837204.vue?vue&type=script&lang=js&"
export * from "./Lgx243725849601837204.vue?vue&type=script&lang=js&"
import style0 from "./Lgx243725849601837204.vue?vue&type=style&index=0&id=c7b080d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7b080d8",
  null
  
)

export default component.exports